namespace Roodik.Game
{
	import Slot = dragonBones.Slot;
	import Graphics = PIXI.Graphics;
	import IPreloader = Roodik.Core.IPreloader;
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	import ViewBase = Roodik.Core.ViewBase;

	export class Preloader extends ViewBase implements IPreloader
	{
		private _graphics: Graphics;
		private _bar:Slot;
		private _delayTween:Tween;

		constructor()
		{
			super("PreloaderScreen");
			
			this.playChildAnimation("logoAnimation", "animtion0", ()=>{
				//console.log("animation complete");
			});
			
			// this.stopChildAnimation("logoAnimation");
			
			this._bar = this.childByName("progress_bar_full");
			this._graphics = new Graphics();
			this._bar.display.mask = this._graphics;
			this._graphics.x = this.x - this._bar.display.width * .5;
			this._graphics.y = this.y - this._bar.display.height * .5;
			this.addChild(this._graphics);
		}

		public update(progress:number)
		{
			let convertedProgress:number = Math.round(progress)/100;
			let calculatedWidth:number = this._bar.display.width * convertedProgress;
			
			this._graphics.lineStyle(1, 0, 1);
			this._graphics.clear();
			this._graphics.beginFill(0xFFFFFF, 1);
			this._graphics.drawRect(0,0,calculatedWidth, this._bar.display.height);
			this._graphics.endFill();
			
			let delay = {d:0};
			if(this._delayTween)
			{
				this._delayTween.stop();
			}
			this._delayTween = new Tween(delay)
			.to({d: 2}, 20000)
			.easing(Easing.Linear.None)
			.onUpdate((o) => {
				
				this._graphics.lineStyle(1, 0, 1);
				this._graphics.clear();
				this._graphics.beginFill(0xFFFFFF, 1);
				this._graphics.drawRect(0, -5,
				calculatedWidth + (this._bar.display.width - calculatedWidth)*o,
				this._bar.display.height + 5);
				this._graphics.endFill();
			})
			.onComplete(() => {
			});
			this._delayTween.start();
		}
		
		public destroy()
		{
			if (this._delayTween != null)
			{
				this._delayTween.stop();
				this._delayTween = null;
			}
			
			this._graphics.destroy();
			this.removeChild(this._graphics);
			
			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Controls/Preloader.ts